// extracted by mini-css-extract-plugin
export default {"profileFormContainer":"userForm_profileFormContainer__BvHKo","readOnly":"userForm_readOnly__LOVdg","pageTitle":"userForm_pageTitle__jH06k"};